module.exports = __webpack_public_path__ + "static/assets/c9e9291b894440ee01b629f17f5c56f7.svg";